import React, { useState } from 'react';
import { ArrowLeft, Camera, CheckCircle, AlertTriangle } from 'lucide-react';
interface InventoryTransferProps {
  onComplete: (hasIssue: boolean) => void;
}
export const InventoryTransfer: React.FC<InventoryTransferProps> = ({
  onComplete
}) => {
  const [step, setStep] = useState(1);
  const [scannedItems, setScannedItems] = useState<string[]>([]);
  const inventoryItems = [{
    id: 'SKU001',
    name: 'Premium Flower - Indica',
    count: 12,
    scanned: false
  }, {
    id: 'SKU002',
    name: 'Premium Flower - Sativa',
    count: 8,
    scanned: false
  }, {
    id: 'SKU003',
    name: 'Concentrates - Live Resin',
    count: 15,
    scanned: true
  }, {
    id: 'SKU004',
    name: 'Edibles - Gummies',
    count: 20,
    scanned: false
  }, {
    id: 'SKU005',
    name: 'Vape Cartridges',
    count: 18,
    scanned: false
  }];
  const scanItem = () => {
    // Simulate scanning an item
    const unscannedItems = inventoryItems.filter(item => !scannedItems.includes(item.id)).map(item => item.id);
    if (unscannedItems.length > 0) {
      const randomIndex = Math.floor(Math.random() * unscannedItems.length);
      const itemId = unscannedItems[randomIndex];
      setScannedItems(prev => [...prev, itemId]);
    }
  };
  const handleNext = () => {
    if (step < 2) {
      setStep(step + 1);
    } else {
      // Check if any items weren't scanned
      const hasIssue = inventoryItems.some(item => !scannedItems.includes(item.id));
      onComplete(hasIssue);
    }
  };
  const isItemScanned = (itemId: string) => scannedItems.includes(itemId);
  return <div className="space-y-4" data-id="element-103">
      <div className="flex items-center mb-4" data-id="element-104">
        <button onClick={() => onComplete(false)} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-gray-100 mr-2" data-id="element-105">
          <ArrowLeft className="w-5 h-5 text-gray-700" data-id="element-106" />
        </button>
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-107">HVM Transfer</h2>
      </div>
      {step === 1 && <>
          <div className="bg-white rounded-lg shadow p-4" data-id="element-108">
            <h3 className="font-medium text-gray-900 mb-4" data-id="element-109">
              Scan High-Value Merchandise
            </h3>
            <div className="space-y-4" data-id="element-110">
              <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-111">
                <button onClick={scanItem} className="px-4 py-2 bg-blue-100 text-blue-700 rounded-md text-sm font-medium inline-flex items-center" data-id="element-112">
                  <Camera className="w-4 h-4 mr-2" data-id="element-113" />
                  Scan Barcode
                </button>
                <p className="text-xs text-gray-500 mt-2" data-id="element-114">
                  Scan each item as you transfer it to the secure storage
                </p>
              </div>
              <div className="space-y-2" data-id="element-115">
                <h4 className="text-sm font-medium text-gray-900" data-id="element-116">
                  Inventory Items
                </h4>
                {inventoryItems.map(item => <div key={item.id} className={`flex items-center justify-between p-3 rounded-md ${isItemScanned(item.id) ? 'bg-green-50' : 'bg-white border border-gray-200'}`} data-id="element-117">
                    <div className="flex items-center" data-id="element-118">
                      {isItemScanned(item.id) ? <CheckCircle className="w-5 h-5 text-green-500 mr-3" data-id="element-119" /> : <div className="w-5 h-5 rounded-full border-2 border-gray-300 mr-3" data-id="element-120" />}
                      <div data-id="element-121">
                        <p className="text-sm font-medium text-gray-900" data-id="element-122">
                          {item.name}
                        </p>
                        <p className="text-xs text-gray-500" data-id="element-123">SKU: {item.id}</p>
                      </div>
                    </div>
                    <span className="text-sm font-medium text-gray-700" data-id="element-124">
                      Count: {item.count}
                    </span>
                  </div>)}
              </div>
            </div>
          </div>
          <button onClick={handleNext} className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors mt-4" disabled={scannedItems.length === 0} data-id="element-125">
            Continue
          </button>
        </>}
      {step === 2 && <>
          <div className="bg-white rounded-lg shadow p-4" data-id="element-126">
            <h3 className="font-medium text-gray-900 mb-4" data-id="element-127">Transfer Summary</h3>
            <div className="space-y-4" data-id="element-128">
              <div className="flex justify-between text-sm" data-id="element-129">
                <span className="text-gray-500" data-id="element-130">Total Items to Transfer</span>
                <span className="font-medium" data-id="element-131">{inventoryItems.length}</span>
              </div>
              <div className="flex justify-between text-sm" data-id="element-132">
                <span className="text-gray-500" data-id="element-133">Items Scanned</span>
                <span className="font-medium" data-id="element-134">{scannedItems.length}</span>
              </div>
              {scannedItems.length < inventoryItems.length && <div className="p-3 bg-yellow-50 rounded-md flex" data-id="element-135">
                  <AlertTriangle className="w-5 h-5 text-yellow-500 mr-2 mt-0.5 flex-shrink-0" data-id="element-136" />
                  <div data-id="element-137">
                    <p className="text-sm font-medium text-gray-900" data-id="element-138">
                      {inventoryItems.length - scannedItems.length} items not
                      scanned
                    </p>
                    <p className="text-xs text-gray-500 mt-1" data-id="element-139">
                      Manager approval will be required to proceed
                    </p>
                  </div>
                </div>}
              <div className="space-y-2" data-id="element-140">
                <label className="block text-sm font-medium text-gray-700" data-id="element-141">
                  Take a photo of the secure storage
                </label>
                <div className="border-2 border-dashed border-gray-300 rounded-lg p-6 text-center" data-id="element-142">
                  <button className="px-4 py-2 bg-blue-100 text-blue-700 rounded-md text-sm font-medium" data-id="element-143">
                    Take Photo
                  </button>
                </div>
              </div>
              <div className="flex items-center" data-id="element-144">
                <input id="confirm-transfer" type="checkbox" className="h-4 w-4 text-blue-600 border-gray-300 rounded" data-id="element-145" />
                <label htmlFor="confirm-transfer" className="ml-2 block text-sm text-gray-900" data-id="element-146">
                  I confirm all items have been transferred to secure storage
                </label>
              </div>
            </div>
          </div>
          <button onClick={handleNext} className="w-full bg-blue-600 text-white py-3 rounded-lg font-medium hover:bg-blue-700 transition-colors mt-4" data-id="element-147">
            Complete Inventory Transfer
          </button>
        </>}
    </div>;
};